import React from 'react';
import { Box, Button, Typography } from '@mui/material';

type Props = {
  onBack: () => void;
};

const LoggedIn: React.FC<Props> = ({ onBack }) => (
  <Box
    sx={{
      maxWidth: 400,
      margin: '40px auto',
      padding: 3,
      border: '1px solid #ccc',
      borderRadius: 2,
      boxShadow: 2,
      textAlign: 'center',
    }}
  >
    <Typography variant="h5" gutterBottom>
      ログインしました
    </Typography>
    <Button variant="outlined" color="primary" onClick={onBack}>
      戻る
    </Button>
  </Box>
);

export default LoggedIn;
